import React from 'react';
import { useNavigate } from 'react-router-dom';

// All password changes now begin with server-verified phone authentication.
export default function UpdatePw() {
  const navigate = useNavigate();
  return (
    <section style={{ width: '100%', maxWidth: 560, padding: 20 }}>
      <h2>비밀번호 재설정</h2>
      <p style={{ marginBottom: 20 }}>가입한 휴대전화로 본인 확인 후 새 비밀번호를 설정할 수 있습니다.</p>
      <button
        type="button"
        style={{ minHeight: 48, padding: '12px 20px', border: 0, borderRadius: 10, background: '#ffda48', color: '#171b24', fontWeight: 700, cursor: 'pointer' }}
        onClick={() => navigate('/findPw')}
      >본인 확인하고 변경하기</button>
    </section>
  );
}
